// extracted by mini-css-extract-plugin
export default {"image":"ModalCarpark_image__9mg5t","modal":"ModalCarpark_modal__P9nTo","temprature":"ModalCarpark_temprature__3yo89","lisence_info":"ModalCarpark_lisence_info__YOQhZ"};